import { type ReactNode } from 'react';

export type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'gold';

// RESTYLE — Web dark-premium identity. Pills con tinte translúcido del color
// (15%) + texto en el color pleno → contrastan sobre las cards oscuras.
const tones: Record<Tone, string> = {
  neutral: 'bg-neutral-100 text-neutral-700',
  success: 'bg-success/15 text-success',
  warning: 'bg-warning/15 text-warning',
  danger: 'bg-danger/15 text-danger',
  info: 'bg-accent/15 text-accent',
  gold: 'bg-fc-gold/15 text-fc-gold',
};

export type BadgeProps = {
  tone?: Tone;
  children: ReactNode;
  className?: string;
  /** Optional ARIA — set when the badge text alone isn't self-describing. */
  ariaLabel?: string;
};

/**
 * Status pill. Use for capacity / sold / available indicators, order status,
 * promo tags. Always inline-flex so it sits next to text without baseline
 * surprises.
 *
 * @example
 *   <Badge tone="success">{soldOut ? 'Agotado' : 'Disponible'}</Badge>
 *   <Badge tone="warning">Quedan {available}</Badge>
 *   <Badge tone="gold">VIP</Badge>
 */
export function Badge({
  tone = 'neutral',
  children,
  className = '',
  ariaLabel,
}: BadgeProps): JSX.Element {
  return (
    <span
      aria-label={ariaLabel}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${tones[tone]} ${className}`.trim()}
    >
      {children}
    </span>
  );
}
